import { PermissionService } from '@abp/ng.core';
import { Component, OnInit } from '@angular/core';
import { SettingsComponent } from '@sestek/premium-reporting/config';
import { FeatureConstants } from 'src/core/constants/feature-constant';
import { PermissionConstants } from 'src/core/constants/permission-constant';
import { SettingsDefinitionModel } from 'src/core/models/shared/settings-definition.model';
import { FeatureService } from 'src/core/services/feature/feature.service';

@Component({
  selector: 'ca-analytics-setting-group',
  templateUrl: './analytics-setting-group.component.html',
  styleUrl: './analytics-setting-group.component.scss',
  standalone: false,
})
export class AnalyticsSettingGroupComponent implements OnInit {
  activeTab: number = 1;

  analyticsEnabled: boolean = false;
  speechRecognitionEnabled: boolean = false;
  premiumReportsEnabled: boolean = false;
  textCorrectionEnabled: boolean = false;
  namedEntityRecognitionEnabled: boolean = false;

  canManageSettings: boolean = false;

  premiumReportsComponent = SettingsComponent;

  settingsDefinitionItems: SettingsDefinitionModel[] = [
    {
      label: '::AttachedData.TitleCase',
      navigationData: ['administration', 'attached-data'],
      extraData: null,
      requiredPolicies: [PermissionConstants.AttachedData, PermissionConstants.SettingManagement],
      forFeatures: [],
    },
    {
      label: '::IgnoredWords',
      navigationData: ['administration', 'ignored-phrases'],
      extraData: null,
      requiredPolicies: [PermissionConstants.IgnoredWords, PermissionConstants.SettingManagement],
      forFeatures: [],
    },
    {
      label: '::Sources',
      navigationData: ['administration', 'sources'],
      extraData: null,
      requiredPolicies: [PermissionConstants.Sources, PermissionConstants.SettingManagement],
      forFeatures: [],
    },
    {
      label: this.taggingLabel,
      navigationData: ['administration', 'tag'],
      extraData: null,
      requiredPolicies: [PermissionConstants.TagAndAutoTagging],
      forFeatures: [],
    },
    {
      label: 'Pronunciation::PronunciationTitle',
      navigationData: ['administration', 'pronunciation'],
      extraData: null,
      requiredPolicies: [PermissionConstants.PronunciationManagement],
      forFeatures: [],
    },
  ];

  get taggingLabel(): string {
    const permission = this.permissionService.getGrantedPolicy(
      PermissionConstants.TagAndAutoTagging
    );

    if (permission) {
      return '::TagsAndAutoTagging';
    }
  }

  constructor(
    private featureService: FeatureService,
    private permissionService: PermissionService
  ) {
    this.analyticsEnabled = this.featureService.isEnabled(FeatureConstants.Analytics);
    this.speechRecognitionEnabled = this.featureService.isEnabled(
      FeatureConstants.ConversationSimulation
    );
    this.premiumReportsEnabled = this.featureService.isEnabled(FeatureConstants.PremiumReporting);
    this.textCorrectionEnabled = this.featureService.isEnabled(FeatureConstants.ChatType);
    this.namedEntityRecognitionEnabled = this.featureService.isEnabled(
      FeatureConstants.FeatureNamedEntityRecognition
    );
    this.canManageSettings = this.permissionService.getGrantedPolicy(
      PermissionConstants.SettingManagement
    );
  }

  ngOnInit(): void {
    if (this.analyticsEnabled && this.canManageSettings) {
      this.activeTab = 1;
    } else {
      this.activeTab = 7;
    }
  }
}
